import React, {Component} from 'react';
import AutoCompleteGroup from '../../forms/auto-complete-group';
import SelectFieldGroup from '../../forms/select-field-group';
import DraggableList from 'react-draggable-list';
import Activity from './activity'
import {detect} from 'detect-browser';

export default class Unit extends Component{
    constructor(props) {
        super(props);
    }

    getDragHeight() {
        return 50;
    }

    render() {
        const {item, itemSelected, dragHandle} = this.props;
        const scale = itemSelected * 0.05 + 1;
        const shadow = itemSelected * 15 + 1;
        const dragged = itemSelected !== 0;
        const browser = detect();

        let actvitiesArray = [];
        let buttonText = '';
        if (item.activities && item.activities.length>0)
        {
            buttonText='Add Another Activity';
            actvitiesArray = item.activities
        }
        else
        {
            buttonText='Add Activity';
        }
        let allUnitsSafari = item.allUnits;
        allUnitsSafari.push({id: 'custom_unit', name: 'Custom Unit'});
        return (
            <li className="ui-state-default">
                <div className="panelBox">
                    <h3>
                        <div className="col-lg-4 col-md-4 col-sm-5">
                            {browser.name !== 'safari' && <AutoCompleteGroup
                                    field="unitValue"
                                    placeholder="Enter Unit Name"
                                    options={item.allUnits}
                                    onBlur={item.onChange}
                                    value={item.unitValue}
                                    id={item.ID}
                                />}
                            {browser.name === 'safari' && !item.hideDropDown && <SelectFieldGroup
                                    field="unitValue"
                                    placeholder="Enter Unit Name"
                                    options={allUnitsSafari}
                                    onChange={item.onChange}
                                    value={item.unitValue}
                                    dropDownId={item.ID}
                                />}
                            {browser.name === 'safari' && item.hideDropDown &&
                                <input
                                    className="form-control"
                                    name="customUnitValue"
                                    placeholder="Enter Unit Name"
                                    onChange={item.onCustomUnitChange}
                                    id={item.ID}
                                    value={item.customUnitValue}
                                    style={{marginTop: '10px'}}
                                />}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-2">
                            {item.error && <div><label className="control-label"/><span className="help-block posRel" style={{'color': 'red'}}>{item.error}</span></div>}
                        </div>
                        <div className="col-md-3 col-sm-5 pull-right">
                            <div className="courseActionButton">
                              {dragHandle(<div className="DrgBtn" />)}
                              <a onClick={item.onDelete} name={item.ID} id={item.ID} className="DltBtn" />
                            </div>
                        </div>
                    </h3>
                    <br/>
                    <ul id="innersortable2">
                        <DraggableList
                            id = {item.ID}
                            itemKey="name"
                            template={Activity}
                            list={actvitiesArray}
                            onMoveEnd={newList => item.onSortingChangeActivity(newList, item.ID)}
                        />
                    </ul>
                    <div className="row">
                        <div className="col-md-12">
                            <button className="addActivityBtn" id={item.ID} onClick={item.onAddActivity} >{buttonText}</button>
                        </div>
                    </div>
                </div>
            </li>
        );
    }
}
